import { ReactNode } from "react";

import { Text } from "@vericus/cadmus-ui";

import * as styles from "./labelled-pill.css";

interface Props {
  label: string;
  value: string;
  extra?: ReactNode;
}

export function LabelledPill({ label, value, extra }: Props) {
  return (
    <div className={styles.pill}>
      <Text kind="bodyMd" as="span" color="lilac700">
        {label}
      </Text>
      <Text kind="bodyMd" as="span" color="lilac700" bold>
        {value}
      </Text>
      {extra}
    </div>
  );
}
